import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { StateStorageService } from '../auth/state-storage.service';
import { SessionQuery } from '../state/session.query';
import { SessionService } from '../state/session.service';


@Injectable()
export class AuthExpiredInterceptor implements HttpInterceptor {
  constructor(
    private sessionService: SessionService,
    private stateStorageService: StateStorageService,
    private router: Router,
    private sessionQuery: SessionQuery
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap({
        error: (err: HttpErrorResponse) => {
          if (err.status === 401 && err.url && !err.url.includes('api/account') && this.sessionQuery.isLoggedIn) {
            this.stateStorageService.storeUrl(this.router.routerState.snapshot.url);
            this.sessionService.login().subscribe();
          }
        },
      })
    );
  }
}
